import { useState, useEffect } from 'react';
import {
  Button,
  ComboTextField,
  GlanceLoader,
  Icon,
  Tooltip
} from '../ui-components';
import React from 'react';

function EnterKeyState({onJoin, onCancel=()=>{}, enableCancelWhenEmpty, gicon, showCancel = true, minKeyLength = 4, languageManager}) {
  const [key, setKey] = useState("");
  const [joinDisabled, setJoinDisabled] = useState(true);
  const [cancelDisabled, setCancelDisabled] = useState(!enableCancelWhenEmpty);

useEffect(() => {
    setCancelDisabled(!enableCancelWhenEmpty)
  }, [enableCancelWhenEmpty]); //This can be modified by the settings.

  function isTooShort(str, minLength=minKeyLength) {
    return str === undefined || str === null || str.trim().length < minLength;
  }

  function joinHandler(event) {
    event.preventDefault();
    if (!joinDisabled) {
      (typeof(onJoin) === typeof(Function)) ? onJoin(key) : console.log('Join button clicked.');
    }
  }

  function cancelHandler(event) {
    event.preventDefault();
    (typeof(onCancel) === typeof(Function)) ? onCancel() : console.log('Cancel button clicked.');
  }

  function keyChangeHandler(keyText) {
    setKey(keyText);
    let invalidKey = isTooShort(keyText);
    setJoinDisabled(invalidKey);
    setCancelDisabled(!enableCancelWhenEmpty&&isTooShort(keyText,1));
  }

  let comboTextField = <ComboTextField
  size="large"
  id="TextInput"
  placeholder={languageManager.getPhrase("integration-enter-key-placeholder",languageManager.getPhrase("integration-enter-key","Enter key"))}//If the language file does not have a placeholder, we use the phrase for "Enter key".
  shape="rounded-full"
  class="enterKeyTextField"
  onChange={(e) => keyChangeHandler(e.target.value)}
  // named slots syntax slot[slotName in camelCase]
  slotIconLeft={<Icon name="key" size="5.5" />}
  slotAction={
    <span className="no-tooltip-arrow">
      <Tooltip text={languageManager.getPhrase("integration-send-offer","Send offer")} position="bottom" flip={true} shift={4} offset={2} size="small">
        <Button
          size="small"
          variant="primary"
          disabled={joinDisabled}
          shape="rounded-full"
          onClick={joinHandler}
        >
          {languageManager.getPhrase("integration-join","Join")}
        </Button>
      </Tooltip>
    </span>
  }
/>

  return (
    <>
      <div className="SizeWrapper">
      <div className="rowAlign">
        { gicon && <GlanceLoader size="12" spinning={false} /> }
        <div className="w-80 mb-25">
        <label htmlFor="TextInput" className="offsetAfterLoader inline-flex items-center gap-1 relative antialiased rtl:text-right typography-body-medium-body20 text-neutral-on-surface-text-default pb-1.5">{languageManager.getPhrase("integration-join-with-key","Join with key")}</label>
          <div className='borderContainer'>
          {comboTextField}
          {showCancel && <span className='buttonSep'>&nbsp;</span>}
          {showCancel && (<Button
            size="medium"
            variant="secondary"
            shape="rounded-full"
            className="cancel"
            disabled={cancelDisabled}
            animation={false}
            outline={true}
            onClick={cancelHandler}
          >
            {languageManager.getPhrase("integration-cancel","Cancel")}
          </Button>)} 
        </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default EnterKeyState;
